


export const Error=()=>{
    return(
        <div id="div" title="404">404</div>
    )
}